import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { NbButton } from "../components/nb";
import { Check, X, TrendingDown } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Cell, ResponsiveContainer, LabelList } from "recharts";

const PRICE_DATA = [
  { name: "qrcupid", price: 8.5, label: "$8.50", highlight: true },
  { name: "Tinder", price: 29.99, label: "$29.99" },
  { name: "Match", price: 31.99, label: "$31.99" },
  { name: "Bumble", price: 39.99, label: "$39.99" },
  { name: "eHarmony", price: 65.9, label: "$65.90" },
];

const COLUMNS = ["qrcupid", "Tinder", "Match", "eHarmony", "Bumble"];
const ROWS = [
  { label: "Monthly price", values: ["$8.50", "$29.99", "$31.99", "$65.90", "$39.99"] },
  { label: "Personal shareable QR code", values: [true, false, false, false, false] },
  { label: "Printed QR cards (100 for $15)", values: [true, false, false, false, false] },
  { label: "Custom badge themes", values: [true, false, false, false, false] },
  { label: "Unlimited messaging", values: [true, "Paid", true, true, true] },
  { label: "See who likes you", values: [true, "Paid", "Paid", "Paid", "Paid"] },
  { label: "No endless swiping", values: [true, false, false, false, false] },
  { label: "Built for real-world events", values: [true, false, false, false, false] },
];

function Cellv({ v }) {
  if (v === true) return <span className="inline-flex w-6 h-6 rounded-full bg-[#F3E8E6] items-center justify-center"><Check className="w-4 h-4 text-[#8B1E3F]" strokeWidth={3} /></span>;
  if (v === false) return <X className="w-4 h-4 text-stone-300 mx-auto" strokeWidth={2.5} />;
  return <span className="text-sm text-stone-600">{v}</span>;
}

export default function Comparison() {
  return (
    <div className="min-h-screen bg-[#FCFCFA]">
      <Navbar />
      <section className="max-w-5xl mx-auto px-6 sm:px-8 py-16">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-stone-500 mb-3 flex items-center justify-center gap-2"><TrendingDown className="w-4 h-4 text-[#8B1E3F]" /> How we compare</div>
          <h1 className="font-display text-5xl sm:text-6xl font-medium tracking-tight text-stone-900">A fraction of the price</h1>
          <p className="text-stone-600 mt-4 leading-relaxed">qrcupid is dramatically more affordable than the major dating apps — with features none of them offer.</p>
        </div>

        {/* Price bar chart */}
        <div className="bg-white rounded-2xl border border-stone-100 shadow-[0_8px_30px_rgb(28,25,23,0.05)] p-6 sm:p-8 mb-8">
          <div className="text-sm font-medium text-stone-700 mb-4">Starting premium price per month (USD)</div>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={PRICE_DATA} layout="vertical" margin={{ left: 8, right: 56, top: 4, bottom: 4 }}>
              <XAxis type="number" hide domain={[0, 72]} />
              <YAxis type="category" dataKey="name" width={110} tick={{ fontFamily: "DM Sans", fontSize: 13, fill: "#57534E" }} axisLine={false} tickLine={false} />
              <Bar dataKey="price" radius={[0, 8, 8, 0]} barSize={26}>
                {PRICE_DATA.map((d, i) => <Cell key={i} fill={d.highlight ? "#8B1E3F" : "#E7E2DC"} />)}
                <LabelList dataKey="label" position="right" style={{ fontFamily: "DM Sans", fontSize: 13, fontWeight: 600, fill: "#1C1917" }} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
          <p className="text-xs text-stone-400 mt-2">Competitor prices are approximate starting rates and vary by plan term and region.</p>
        </div>

        {/* Feature comparison table */}
        <div className="bg-white rounded-2xl border border-stone-100 shadow-[0_8px_30px_rgb(28,25,23,0.05)] overflow-x-auto" data-testid="comparison-table">
          <table className="w-full min-w-[680px]">
            <thead>
              <tr className="border-b border-stone-100">
                <th className="text-left p-4 text-sm font-medium text-stone-500 w-1/3">Feature</th>
                {COLUMNS.map((c) => (
                  <th key={c} className={`p-4 text-center text-sm ${c === "qrcupid" ? "bg-[#FBF4F2]" : ""}`}>
                    <span className={`font-medium ${c === "qrcupid" ? "text-[#8B1E3F]" : "text-stone-700"}`}>{c}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row, ri) => (
                <tr key={ri} className="border-b border-stone-50 last:border-0">
                  <td className="p-4 text-sm text-stone-700">{row.label}</td>
                  {row.values.map((v, ci) => (
                    <td key={ci} className={`p-4 text-center ${ci === 0 ? "bg-[#FBF4F2] font-medium" : ""}`}><Cellv v={v} /></td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="text-center mt-12">
          <NbButton as={Link} to="/register" className="px-9 py-3.5">Join qrcupid for $8.50/mo</NbButton>
        </div>
      </section>
      <Footer />
    </div>
  );
}
